<app-header1></app-header1>
<div class="section-full p-t30 p-b40 ">
    <div class="container">
        <!-- TITLE START-->
        <div class="section-head center wt-small-separator-outer text-center text-white faq-h">
            <div class="wt-small-separator site-text-secondry">
                <!-- <div class="sep-leaf-left"></div> -->
                <div class="section-heading">FAQ<span class="section-headspan">s</span></div>
            </div>
            <h4 >Get every single answers here</h4>
        </div>
        <!-- TITLE END-->

  <div class="section-content">
  <div class="faq-outer">
    <div class="row">
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for first half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion1">

          <!-- FAQ 1 -->
          <div class="panel wt-panel theme1">
            <div class="acod-head acc-actives">
                <h4 class="acod-title">
                    <a data-toggle="collapse" href="#faq1" class="" data-parent="#accordion1">
                        What services does Soul Space provide?
                        <span class="indicator"><i class="fa fa-minus"></i></span>
                    </a>
                </h4>
            </div>
            <div id="faq1" class="acod-body collapse show">
                <div class="acod-content">
                    <p>Soul Space offers a wide range of mental health services, including individual and group counseling, psychological assessments, virtual reality (VR) meditation, biofeedback therapy, corporate wellness programs, and more.</p>
                </div>
            </div>
            </div>
            </div>
            </div>
          <div class="col-lg-6 col-md-6">
            <!-- Accordian for first half of FAQs -->
          <div class="wt-accordion faq-accorfion m-b30" id="accordion2">
          <!-- FAQ 2 -->
          <div class="panel wt-panel theme2">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq2" class="collapsed" data-parent="#accordion2">
                  How do I know if I need mental health support?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq2" class="acod-body collapse">
              <div class="acod-content">
                <p>If you're experiencing prolonged stress, anxiety, depression, or difficulty managing everyday activities, it might be helpful to consult with a mental health professional.</p>
              </div>
            </div>
          </div>

          <!-- Add more FAQs here as needed -->

        </div>
      </div>

      <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion3">

          <!-- FAQ 3 -->
          <div class="panel wt-panel theme3">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq3" class="collapsed" data-parent="#accordion3">
                  Do you offer services for families and couples?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq3" class="acod-body collapse">
              <div class="acod-content">
                <p>Yes, we offer family counseling and couples therapy to help resolve conflicts, improve communication, and build stronger emotional connections.</p>
              </div>
            </div>
          </div>
          </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <!-- Accordian for second half of FAQs -->
          <div class="wt-accordion faq-accorfion m-b30" id="accordion4">
          <!-- FAQ 4 -->
          <div class="panel wt-panel theme4">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq4" class="collapsed" data-parent="#accordion4">
                  What can I expect during an initial consultation?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq4" class="acod-body collapse">
              <div class="acod-content">
                <p>During your first session, you’ll meet with one of our professionals to discuss your concerns, history, and goals. The consultation helps us design a personalized treatment plan.</p>
              </div>
            </div>
          </div>

          <!-- Add more FAQs here as needed -->

        </div>
      </div>
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion5">

          <!-- FAQ 5 -->
          <div class="panel wt-panel theme1">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq5" class="collapsed" data-parent="#accordion5">
                    What is biofeedback therapy and how can it benefit me?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq5" class="acod-body collapse">
              <div class="acod-content">
                <p>Biofeedback therapy helps individuals understand and control their body’s physiological responses to stress, such as heart rate, breathing, and muscle tension. It’s a highly effective technique for managing anxiety, stress, and other emotional conditions by teaching you how to regulate your body’s responses.</p>
              </div>
            </div>
          </div>
          </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <!-- Accordian for second half of FAQs -->
          <div class="wt-accordion faq-accorfion m-b30" id="accordion6">
          <!-- FAQ 6-->
          <div class="panel wt-panel theme2">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq6" class="collapsed" data-parent="#accordion6">
                    What is virtual reality (VR) meditation, and who can benefit from it?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq6" class="acod-body collapse">
              <div class="acod-content">
                <p>VR meditation uses immersive technology to create calming, virtual environments that support relaxation and mindfulness. It is beneficial for individuals dealing with stress, anxiety, focus issues, and those looking to improve their overall mental health. The tailored experiences can be customized to individual needs.
                </p>
              </div>
            </div>
          </div>

          <!-- Add more FAQs here as needed -->

        </div>
      </div>
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion7">

          <!-- FAQ 7 -->
          <div class="panel wt-panel theme3">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq7" class="collapsed" data-parent="#accordion7">
                    What kind of psychological assessments do you provide?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq7" class="acod-body collapse">
              <div class="acod-content">
                <p>We offer a variety of psychological assessments, including IQ testing, personality assessments, emotional and behavioral evaluations, and screenings for conditions such as depression, anxiety, ADHD, and other mental health disorders. These assessments help in identifying areas for intervention and support.</p>
              </div>
            </div>
          </div>
          </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <!-- Accordian for second half of FAQs -->
          <div class="wt-accordion faq-accorfion m-b30" id="accordion8">
    
          <!-- FAQ 8-->
          <div class="panel wt-panel theme4">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq8" class="collapsed" data-parent="#accordion8">
                    Can I schedule an online counseling session?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq8" class="acod-body collapse">
              <div class="acod-content">
                <p>Yes, we offer both in-person and online counseling sessions to meet the needs of our clients. You can choose the option that works best for you. Our secure online platform ensures confidentiality and ease of access from the comfort of your home.
                </p>
              </div>
            </div>
          </div>

          <!-- Add more FAQs here as needed -->

        </div>
      </div>
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion9">

          <!-- FAQ 9 -->
          <div class="panel wt-panel theme1">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq9" class="collapsed" data-parent="#accordion9">
                    Do you provide mental health programs for organizations or corporate clients?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq9" class="acod-body collapse">
              <div class="acod-content">
                <p>Yes, we offer tailored corporate wellness programs that focus on reducing workplace stress, improving mental health, and fostering productivity and well-being in professional settings. These programs include workshops, employee counseling, stress management techniques, and resilience training.
                </p>
              </div>
            </div>
          </div>
          </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <!-- Accordian for second half of FAQs -->
          <div class="wt-accordion faq-accorfion m-b30" id="accordion10">
    
          <!-- FAQ 10 -->
          <div class="panel wt-panel theme2">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq10" class="collapsed" data-parent="#accordion10">
                    What are the benefits of group counseling?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq10" class="acod-body collapse">
              <div class="acod-content">
                <p>Group counseling offers individuals a supportive environment where they can share experiences, learn from others, and develop new coping skills. It is particularly effective for people dealing with similar challenges, such as stress, anxiety, or grief, as it fosters connection and mutual understanding.
                </p>
              </div>
            </div>
          </div>

          <!-- Add more FAQs here as needed -->

        </div>
      </div>
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion11">

          <!-- FAQ 11 -->
          <div class="panel wt-panel theme3">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq11" class="collapsed" data-parent="#accordion11">
                    Are Soul Space’s services suitable for children and adolescents?
                    <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq11" class="acod-body collapse">
              <div class="acod-content">
                <p>Yes, we provide specialized mental health services for children and adolescents, including emotional and behavioral assessments, counseling, and therapeutic interventions. Our programs are designed to support the mental well-being of young individuals at various stages of development.</p>
              </div>
            </div>
          </div>
          </div>
          </div>
        <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion12">
          <!-- FAQ 12 -->
          <div class="panel wt-panel theme4">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq12" class="collapsed" data-parent="#accordion12">
                    How can mental health services improve my life?

                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq12" class="acod-body collapse">
              <div class="acod-content">
                <p>Mental health services help you better understand your emotions, manage stress, improve relationships, and develop healthier coping strategies. Whether you’re dealing with a specific mental health issue or simply looking to improve your overall well-being, these services can enhance your emotional resilience and quality of life.
                </p>
              </div>
            </div>
          </div>

          <!-- Add more FAQs here as needed -->

        </div>
      </div>
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion13">

          <!-- FAQ 13 -->
          <div class="panel wt-panel theme1">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq13" class="collapsed" data-parent="#accordion13">
                    How do you maintain confidentiality during counseling?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq13" class="acod-body collapse">
              <div class="acod-content">
                <p>Confidentiality is of utmost importance to us. All client information and counseling sessions are kept private in accordance with ethical standards and legal requirements. We only share information with consent or if required by law in cases of safety concerns.</p>
              </div>
            </div>
          </div>
          </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <!-- Accordian for second half of FAQs -->
          <div class="wt-accordion faq-accorfion m-b30" id="accordion14">
    
          <!-- FAQ 14 -->
          <div class="panel wt-panel theme2">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq14" class="collapsed" data-parent="#accordion14">
                    Do you offer support for people with disabilities?

                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq14" class="acod-body collapse">
              <div class="acod-content">
                <p>Yes, we provide mental health support tailored to individuals with disabilities, including those with physical, developmental, and learning disabilities. Our team works to create customized programs that address their unique mental health needs, ensuring holistic and compassionate care.
                </p>
              </div>
            </div>
          </div>
          </div>
          </div>

          <!-- Add more FAQs here as needed -->

        
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion15">

          <!-- FAQ 15 -->
          <div class="panel wt-panel theme3">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq15" class="collapsed" data-parent="#accordion15">
                    Can Soul Space work with schools and educational institutions?

                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq15" class="acod-body collapse">
              <div class="acod-content">
                <p>Yes, we collaborate with schools to offer mental health assessments, student counseling, teacher training, and holistic wellness programs aimed at promoting mental well-being in educational settings. Our school mental health program is comprehensive and tailored to the specific needs of each institution.
                </p>
              </div>
            </div>
          </div>
          </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <!-- Accordian for second half of FAQs -->
          <div class="wt-accordion faq-accorfion m-b30" id="accordion16">
    
          <!-- FAQ 16-->
          <div class="panel wt-panel theme4">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq16" class="collapsed" data-parent="#accordion16">
                    How can I make an appointment?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq16" class="acod-body collapse">
              <div class="acod-content">
                <p>You can easily book an appointment by contacting us through our website, calling our office, or sending an inquiry via email. We offer flexible scheduling, including evening and weekend appointments, to accommodate your needs.
                </p>
              </div>
            </div>
          </div>

          <!-- Add more FAQs here as needed -->

        </div>
      </div>
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion17">

          <!-- FAQ 17 -->
          <div class="panel wt-panel theme1">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq17" class="collapsed" data-parent="#accordion17">
                    What are your rates and payment options?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq17" class="acod-body collapse">
              <div class="acod-content">
                <p>Our rates vary depending on the service and duration of the session. We offer competitive pricing and flexible payment options, including packages for long-term counseling and wellness programs. Please contact us for more detailed pricing information.
                </p>
              </div>
            </div>
          </div>
          </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <!-- Accordian for second half of FAQs -->
          <div class="wt-accordion faq-accorfion m-b30" id="accordion18">
    
          <!-- FAQ 18-->
          <div class="panel wt-panel theme2">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq18" class="collapsed" data-parent="#accordion18">
                    How do I contact Soul Space for more information?

                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq18" class="acod-body collapse">
              <div class="acod-content">
                <p>You can reach us through the contact form on our website, via email, or by calling our office directly. We’re happy to answer any questions you have and help you get started on your mental health journey.
                </p>
              </div>
            </div>
          </div>

          <!-- Add more FAQs here as needed -->

        </div>
      </div>
    </div>
  </div>
</div>

    </div>
</div>

<div class="section-full p-t20 p-b10 bg-white">
    <div class="container">
        <!-- TITLE START-->
        <div class="section-head center wt-small-separator-outer text-center text-white">
            
            <h4>School Mental Health Program</h4>
        </div>
        <!-- TITLE END-->

  <div class="section-content">
  <div class="faq-outer">
    <div class="row">
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for first half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion19">

          <!-- FAQ 1 -->
          <div class="panel wt-panel theme3">
            <div class="acod-head acc-actives">
                <h4 class="acod-title">
                    <a data-toggle="collapse" href="#faq19" class="collapsed" data-parent="#accordion19">
                        What is the Soul Space School Mental Health Program?
                        <span class="indicator"><i class="fa fa-plus"></i></span>
                    </a>
                </h4>
            </div>
            <div id="faq19" class="acod-body collapse">
                <div class="acod-content">
                    <p>Our School Mental Health Program is a holistic initiative that integrates psychological assessments, counseling, nutritional support, and mental wellness activities. It aims to promote emotional and mental well-being in students through targeted interventions in schools.
                    </p>
                </div>
            </div>
            </div>
            </div>
            </div>
            <div class="col-lg-6 col-md-6">
            <div class="wt-accordion faq-accorfion m-b30" id="accordion20">

              <!-- FAQ 1 -->
          <div class="panel wt-panel theme4">
          <!-- FAQ 2 -->
          
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq20" class="collapsed" data-parent="#accordion20">
                    What age groups do your programs cater to?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq20" class="acod-body collapse">
              <div class="acod-content">
                <p>Our programs are designed to cater to children from ages 8 to 18, with age-specific programs for early childhood, primary school, middle school, and high school students. Each program is tailored to address the developmental, emotional, and psychological needs of the specific age group.
                </p>
              </div>
            </div>
          

          <!-- Add more FAQs here as needed -->

        </div>
      </div>
    </div>
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion21">

          <!-- FAQ 3 -->
          <div class="panel wt-panel theme1">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq21" class="collapsed" data-parent="#accordion21">
                    How do I know if my child needs mental health support?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq21" class="acod-body collapse">
              <div class="acod-content">
                <p>Look out for signs such as sudden changes in behavior, difficulty in school, social withdrawal, frequent mood swings, or persistent feelings of sadness or anxiety. If you are unsure, our initial assessments can help determine if your child may benefit from mental health support.
                </p>
              </div>
            </div>
          </div>
          </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <!-- Accordian for second half of FAQs -->
          <div class="wt-accordion faq-accorfion m-b30" id="accordion22">
    
          <!-- FAQ 4 -->
          <div class="panel wt-panel theme2">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq22" class="collapsed" data-parent="#accordion22">
                    Is your program in line with WHO guidelines?

                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq22" class="acod-body collapse">
              <div class="acod-content">
                <p>Yes, our programs are developed based on guidelines from the World Health Organization (WHO) and other global mental health standards, ensuring we provide the highest quality of care and support.</p>
              </div>
            </div>
          </div>

          <!-- Add more FAQs here as needed -->

        </div>
      </div>
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion23">

          <!-- FAQ 5 -->
          <div class="panel wt-panel theme3">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq23" class="collapsed" data-parent="#accordion23">
                    How do you ensure confidentiality in counseling sessions?

                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq23" class="acod-body collapse">
              <div class="acod-content">
                <p>We adhere to strict privacy policies to ensure that all counseling sessions are confidential. Personal information is protected and shared only with consent, in accordance with local regulations and ethical standards.
                </p>
              </div>
            </div>
          </div>
          </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <!-- Accordian for second half of FAQs -->
          <div class="wt-accordion faq-accorfion m-b30" id="accordion24">
    
          <!-- FAQ 6-->
          <div class="panel wt-panel theme4">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq24" class="collapsed" data-parent="#accordion24">
                    What is included in the mental health assessments for students?

                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq24" class="acod-body collapse">
              <div class="acod-content">
                <p>Our student mental health assessments include psychological evaluations, emotional well-being checks, and IQ assessments. These are conducted to identify emotional, behavioral, or learning challenges, and to provide targeted support for the students.
                </p>
              </div>
            </div>
          </div>

          <!-- Add more FAQs here as needed -->

        </div>
      </div>
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion25">

          <!-- FAQ 7 -->
          <div class="panel wt-panel theme1">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq25" class="collapsed" data-parent="#accordion25">
                    How does the program address the needs of children with disabilities?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq25" class="acod-body collapse">
              <div class="acod-content">
                <p>We offer specialized mental health services for children with disabilities, including assessments, individualized support plans, and tailored therapeutic interventions. Our goal is to ensure these students receive the support they need for their unique emotional and developmental challenges.
                </p>
              </div>
            </div>
          </div>
          </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <!-- Accordian for second half of FAQs -->
          <div class="wt-accordion faq-accorfion m-b30" id="accordion26">
    
          <!-- FAQ 8-->
          <div class="panel wt-panel theme2">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq26" class="collapsed" data-parent="#accordion26">
                    How is AI used in your mental health services?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq26" class="acod-body collapse">
              <div class="acod-content">
                <p>We utilize AI-powered emotion recognition technology to provide real-time insights into students' emotional states. This helps in offering timely support based on facial expressions, voice patterns, and other indicators of emotional well-being.

                </p>
              </div>
            </div>
          </div>

          <!-- Add more FAQs here as needed -->

        </div>
      </div>
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion27">

          <!-- FAQ 9 -->
          <div class="panel wt-panel theme3">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq27" class="collapsed" data-parent="#accordion27">
                    How does Virtual Reality (VR) Meditation work?

                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq27" class="acod-body collapse">
              <div class="acod-content">
                <p>Our VR meditation pods provide immersive, guided meditation experiences that are tailored to individual emotional needs. Students can engage in calming virtual environments designed to help reduce anxiety, improve focus, and promote mental well-being.


                </p>
              </div>
            </div>
          </div>
          </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <!-- Accordian for second half of FAQs -->
          <div class="wt-accordion faq-accorfion m-b30" id="accordion28">
    
          <!-- FAQ 10 -->
          <div class="panel wt-panel theme4">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq28" class="collapsed" data-parent="#accordion28">
                    What is biofeedback and how does it help students?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq28" class="acod-body collapse">
              <div class="acod-content">
                <p>Biofeedback is a technique that helps students understand and regulate their physiological responses to stress. Using wearables and technology, students learn how to manage their body’s reactions, leading to improved emotional regulation and stress management.

                </p>
              </div>
            </div>
          </div>

          <!-- Add more FAQs here as needed -->

        </div>
      </div>
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion29">

          <!-- FAQ 11 -->
          <div class="panel wt-panel theme1">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq29" class="collapsed" data-parent="#accordion29">
                    Can parents and teachers get involved in the mental health program?
                    <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq29" class="acod-body collapse">
              <div class="acod-content">
                <p>Absolutely! We believe in a collaborative approach. Our programs offer parent and teacher training sessions, equipping them with tools and techniques to support the mental well-being of children both at home and in the classroom.
                </p>
              </div>
            </div>
          </div>
          </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <!-- Accordian for second half of FAQs -->
          <div class="wt-accordion faq-accorfion m-b30" id="accordion30">
    
          <!-- FAQ 12 -->
          <div class="panel wt-panel theme2">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq30" class="collapsed" data-parent="#accordion30">
                    Do you offer group counseling or peer support programs?


                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq30" class="acod-body collapse">
              <div class="acod-content">
                <p>Yes, we offer both group counseling sessions and peer support networks. Group counseling provides students with a safe space to share their concerns and learn coping strategies, while peer support networks foster empathy, connection, and emotional resilience among students.
                </p>
              </div>
            </div>
          </div>

          <!-- Add more FAQs here as needed -->

        </div>
      </div>
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion31">

          <!-- FAQ 13 -->
          <div class="panel wt-panel theme3">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq31" class="collapsed" data-parent="#accordion31">
                    Can schools collaborate with Soul Space for mental health programs?

                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq31" class="acod-body collapse">
              <div class="acod-content">
                <p>Yes! We work with schools to integrate our mental health programs into their curriculum. Schools can benefit from our psychological assessments, training for teachers, and student wellness programs, ensuring comprehensive mental health support for their students.
                </p>
              </div>
            </div>
          </div>

          

          
          <!-- Add more FAQs here as needed -->

        </div>
      </div>
      <div class="col-lg-6 col-md-6">
        <!-- Accordian for second half of FAQs -->
        <div class="wt-accordion faq-accorfion m-b30" id="accordion32">

          <!-- FAQ 17 -->
          <div class="panel wt-panel theme4">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq32" class="collapsed" data-parent="#accordion32">
                    What are your rates and payment options?
                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq32" class="acod-body collapse">
              <div class="acod-content">
                <p>Our rates vary depending on the service and duration of the session. We offer competitive pricing and flexible payment options, including packages for long-term counseling and wellness programs. Please contact us for more detailed pricing information.
                </p>
              </div>
            </div>
          </div>
          </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <!-- Accordian for second half of FAQs -->
          <div class="wt-accordion faq-accorfion m-b30" id="accordion33">
    
          <!-- FAQ 18-->
          <div class="panel wt-panel theme1">
            <div class="acod-head acc-actives">
              <h4 class="acod-title">
                <a data-toggle="collapse" href="#faq33" class="collapsed" data-parent="#accordion33">
                    How do I contact Soul Space for more information?

                  <span class="indicator"><i class="fa fa-plus"></i></span>
                </a>
              </h4>
            </div>
            <div id="faq33" class="acod-body collapse">
              <div class="acod-content">
                <p>You can reach us through the contact form on our website, via email, or by calling our office directly. We’re happy to answer any questions you have and help you get started on your mental health journey.
                </p>
              </div>
            </div>
          </div>

          <!-- Add more FAQs here as needed -->

        </div>
      </div>
    </div>
  </div>
</div>

    </div>
</div>
<app-footer1></app-footer1>
<app-loader></app-loader>